import { FC } from 'react';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import Stack from '@mui/material/Stack';
import { ISidebarFooterProps } from '@cbridge-modules/sidebar';

export const DashboardsSidebarFooter: FC<ISidebarFooterProps> = (props) => {
  const { mini, toggleAction } = props;

  return (
    <Stack
      component={'ul'}
      sx={{
        m: 0,
        p: 0,
      }}>
      <Divider />
      <ListItem
        sx={{
          justifyContent: mini ? 'center' : 'right',
          overflowX: 'hidden',
        }}
      >
        {toggleAction}
      </ListItem>
    </Stack>
  );
};
